import styled from 'styled-components';

export const StyledKeyContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1.6rem;
  border-radius: 0.6rem;
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  color: ${({ theme }) => theme.colors.text.main};
  height: 7.8rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    align-items: center;
    height: 5rem;
  }
`;

export const StyledItems = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  width: 60%;
  flex-wrap: wrap;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    grid-template-columns: repeat(4, auto);
    width: 100%;
  }
`;

export const StyledKeyTitle = styled.div`
  font-size: 1.4rem;
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
`;

export const StyledKeyName = styled.div`
  display: block;
  font-size: 1.4rem;
`;

export const StyledKeyWrapper = styled.div`
  display: flex;
  gap: 0.4rem;
`;

export const StyledKey = styled.div<{ level: 0 | 1 | 2 | 3 }>`
  display: flex;
  border-radius: 0.6rem;
  width: 1.8rem;
  height: 1.8rem;

  background-color: ${({ theme, level }) => {
    switch (level) {
      case 0: {
        return theme.colors.activityCalendar.levelZero;
      }
      case 1: {
        return theme.colors.activityCalendar.levelOne;
      }
      case 2: {
        return theme.colors.activityCalendar.levelTwo;
      }
      case 3: {
        return theme.colors.activityCalendar.levelThree;
      }
      default: {
        return theme.colors.activityCalendar.levelZero;
      }
    }
  }};
`;
